import React, { useRef } from "react";
import * as Immutable from "immutable";
import { Alert } from "components/bootstrap";
import { Spinner } from "components/common";
import MessageTable from "components/common/message/messagetable/MessageTable";
import AutoRefreshDisabledProvider from "report/common/AutoRefreshDisabledProvider";
import WindowDimensionsContextProvider from "contexts/WindowDimensionsContextProvider";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import FieldActionsContext from "views/components/actions/FieldActionsContext";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import MessagesWidgetConfig from "views/logic/widgets/MessagesWidgetConfig";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { DEFAULT_MESSAGE_FIELDS, TIMESTAMP_FIELD } from "views/Constants";
import {
  AddFavoriteFieldActionPlugin,
  CopyToClipboardFieldActionPlugin,
  RemoveFavoriteFieldActionPlugin
} from "views/actions/FieldActionPlugins";
import { CopyToClipBoardValueActionPlugin, CreateExtractorValueActionPlugin } from "views/actions/ValueActionPlugins";
import { InsertIntoViewValueActionPlugin } from "enterprise/parameters/actions/ValueActionPlugins";
const actionConfig = {
  evaluateCondition: (conditionFn, handlerArgs) => conditionFn(handlerArgs),
  additionalHandlerArgs: {},
  fieldActions: [CopyToClipboardFieldActionPlugin, AddFavoriteFieldActionPlugin, RemoveFavoriteFieldActionPlugin],
  valueActions: [InsertIntoViewValueActionPlugin, CreateExtractorValueActionPlugin, CopyToClipBoardValueActionPlugin]
};
const setLoadingState = () => void 0;
const rowOverride = (message) => {
  var _a;
  return Object.keys((_a = message.fields) != null ? _a : {}).every((fieldName) => fieldName === "_id" || fieldName === TIMESTAMP_FIELD) ? `This log message with ID ${message.id} is no longer available. It could not be found in its source index.` : void 0;
};
const SelectedLogsTable = ({ logs }) => {
  const scrollContainerRef = useRef();
  const { data: fieldTypes, isLoading: loadingFieldTypes } = useFieldTypes([], void 0);
  const allFieldTypes = Immutable.List(fieldTypes != null ? fieldTypes : []);
  const fieldTypesContextValue = {
    all: allFieldTypes,
    currentQuery: allFieldTypes
  };
  if (logs.length === 0) {
    return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, "No logs selected by AI.");
  }
  if (loadingFieldTypes) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading fields..." });
  }
  return /* @__PURE__ */ React.createElement(AutoRefreshDisabledProvider, null, /* @__PURE__ */ React.createElement(WindowDimensionsContextProvider, null, /* @__PURE__ */ React.createElement(FieldTypesContext.Provider, { value: fieldTypesContextValue }, /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: "interactive" }, /* @__PURE__ */ React.createElement(FieldActionsContext.Provider, { value: actionConfig }, /* @__PURE__ */ React.createElement(
    MessageTable,
    {
      config: MessagesWidgetConfig.builder().fields(DEFAULT_MESSAGE_FIELDS).showMessageRow(true).showSummary(true).decorators([]).sort([]).build(),
      scrollContainerRef,
      fields: allFieldTypes,
      setLoadingState,
      messages: logs,
      rowOverride
    }
  ))))));
};
export default SelectedLogsTable;
